<template>
  <search
    ref="search"
    class="player-search"
    source="players"
    v-bind="$attrs"
    :placeholder="placeholder"
    v-on="$listeners"
  >
    <template #default="slotProps">
      <index-list-item :index="slotProps.item" />
    </template>
  </search>
</template>

<script>
import Search from '@/components/Search';

import IndexListItem from '@cardladder/shared/components/IndexListItem';

export default {
  components: {
    Search,
    IndexListItem,
  },

  props: {
    placeholder: {
      type: String,
      default: 'Search for a player',
    },
  },

  methods: {
    focus() {
      this.$refs.search.focus();
    },

    clear() {
      this.$refs.search.clear();
    },
  },
};
</script>
